import {OUTAGE_INTERSTITIAL} from 'src/pages/scheduleCallback/constants/views';
import {fragment} from 'src/pages/scheduleCallback/utils';
import {changeView} from 'src/shared/currentView/actions';
import {logScreenName} from 'src/shared/dataLayer/loggers';
import {pushHistory} from 'src/shared/history/actions';

export const outageDetectedStep = outages => dispatch => {
  dispatch(pushHistory(outageDetectedStep(outages), fragment('outage')));
  dispatch(changeView(OUTAGE_INTERSTITIAL));
  logScreenName('outageinterstitial');
};
